<template>
  <v-card flat rounded="lg">
    <v-card-title class="subtitle-1 font-weight-bold"
      >Dados Cadastrais</v-card-title
    >
    <v-card-text>
      <v-form ref="form">
        <v-row>
          <v-col xl="2" lg="2" md="2" cols="12">
            <v-text-field
              label="Matrícula"
              v-model="clienteManut.matricula"
              disabled
            ></v-text-field>
          </v-col>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-text-field
              label="Nome"
              v-model="clienteManut.nome"
              :disabled="editar"
            ></v-text-field>
          </v-col>
          <v-col xl="4" lg="4" md="4" cols="12">
            <v-text-field
              label="Apelido"
              v-model="clienteManut.apelido"
            ></v-text-field>
          </v-col>
          <v-col xl="2" lg="2" md="2" cols="12" align-self="center">
            <v-select
              :items="tiposPessoa"
              item-text="text"
              item-value="value"
              label="Tipo pessoa"
              v-model="clienteManut.tipo"
              :disabled="editar"
            ></v-select>
          </v-col>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-text-field
              :label="isSelecPessoaJurid() ? 'CNPJ' : 'CPF'"
              v-model="clienteManut.cpf_cnpj"
              v-mask="isSelecPessoaJurid() ? '##############' : '###########'"
              :disabled="editar"
              type="text"
            ></v-text-field>
          </v-col>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-text-field
              :label="isSelecPessoaJurid() ? 'Inscrição Estadual' : 'RG'"
              v-model="clienteManut.rg"
              v-mask="'##########'"
              :disabled="editar"
            ></v-text-field>
          </v-col>
          <template v-if="!isSelecPessoaJurid()">
            <v-col xl="1" lg="1" md="1" cols="12">
              <v-text-field
                label="SSP"
                v-model="clienteManut.ssp"
                :disabled="editar"
              ></v-text-field>
            </v-col>
            <v-col xl="3" lg="3" md="3" cols="12">
              <v-text-field
                label="Data de nascimento"
                v-model="clienteManut.dtnascimento"
                type="date"
                :disabled="editar"
              ></v-text-field>
            </v-col>
            <v-col xl="3" lg="3" md="3" cols="12" align-self="center">
              <v-select
                label="Sexo"
                :items="sexos"
                item-text="text"
                value="value"
                v-model="clienteManut.sexo"
                :disabled="editar"
              >
              </v-select>
            </v-col>
            <v-col xl="4" lg="4" md="4" cols="12" align-self="center">
              <v-select
                label="Estado Civil"
                :items="estadosCivis"
                item-text="descricao"
                value="value"
                v-model="clienteManut.estadocivil"
                :disabled="editar"
              >
              </v-select
            ></v-col>
          </template>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: mapState("clientes", ["clienteManut", "editar", "estadosCivis"]),
  data: () => ({
    sexos: [
      { text: "Masculino", value: "M" },
      { text: "Feminino", value: "F" },
    ],
    tiposPessoa: [
      { text: "Física", value: "F" },
      { text: "Jurídica", value: "J" },
    ],
  }),
  methods: {
    ...mapGetters("clientes", ["isSelecPessoaJurid"]),
  },
};
</script>

<style>
</style>